module.exports = __webpack_public_path__ + "img/bold.7d8a5c42.svg";